import CRM from '@/views/CRM.vue';
import Activities from '@/views/CRM/Activities.vue';
import Activity from '@/views/CRM/Activities/Activity.vue';

import QualityAssurance from '@/views/CRM/QualityAssurance.vue';
import Segments from '@/views/CRM/Segments.vue';

export default [
  {
    path: '/crm',
    name: 'crm',
    component: CRM,
    meta: {
      requiresAuth: true,
      view: 'crm',
    },
    children: [
      {
        path: 'activities/list',
        component: Activities,
        name: 'crm.activities',
        meta: {
          view: 'activities',
        },
      },
      {
        path: 'activity/:id?',
        component: Activity,
        name: 'crm.activity',
        props: true,
      },
      {
        path: 'running',
        component: Activities,
        name: 'crm.running',
        meta: {
          view: 'running',
        },
      },
      {
        path: 'quality-assurance',
        component: QualityAssurance,
        name: 'crm.quality-assurance',
        meta: {
          view: 'quality_assurance',
        },
        children: [
          {
            path: 'activities',
            component: Activities,
            name: 'crm.quality-assurance-activities',
            meta: {
              view: 'quality-assurance-activities',
            },
          },
          {
            path: 'segments',
            component: Segments,
            name: 'crm.quality-assurance-segments',
            meta: {
              view: 'quality-assurance-segments',
            },
          },
        ],
      },
      {
        path: 'segments',
        component: Segments,
        name: 'segments',
        meta: {
          view: 'segments',
        },
      },
      {
        path: '',
        name: 'crm.empty',
        redirect: {
          name: 'crm.activities',
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'crm.catch-all',
        redirect: {
          name: 'crm.activities',
        },
      },
    ],
  },
];
